import React, { Component } from 'react'
import { BrowserRouter } from 'react-router'
import Media from 'react-media'
import AppDesktop from './AppDesktop'
import AppMobile from './AppMobile'

export default class App extends Component {
  render(){
    return (
      <BrowserRouter>
        <Media query="(min-width: 800px)">
          {matches => matches
            ? <AppDesktop {...this.props}/>
            : <AppMobile {...this.props}/>
          }
        </Media>
      </BrowserRouter>
    )
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/App.js
 **/